import ReviewsBlock from './ReviewsBlock.vue'

export default ReviewsBlock
